import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Typography, Paper, Stack, IconButton } from "@mui/material";
import JsonView from "@uiw/react-json-view";

import { useAppSelector } from "~/app/store";
import { selectServerConfig } from "~/redux/selectors/appSelectors";

type GenericConfigObject = Record<string, unknown>;

function copyJsonToClipboard(data: GenericConfigObject | null) {
  if (!data) return;
  const jsonString = JSON.stringify(data, null, 2);

  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(jsonString).catch(() => {
      // do nothing
    });
  }
}

const ClientConfigurations = () => {
  const activeConfig = useAppSelector(selectServerConfig);
  const configLabel = "Active Configuration";

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 800 }} elevation={2}>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Typography variant="h6" sx={{ mb: 0 }}>
            {configLabel}
          </Typography>
          {activeConfig && (
            <IconButton
              aria-label="Copy client configuration"
              size="small"
              onClick={() => copyJsonToClipboard(activeConfig)}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
        {activeConfig ? (
          <div role="region" aria-label="Client configuration details">
            <JsonView
              value={activeConfig}
              indentWidth={4}
              enableClipboard={false}
              displayDataTypes={false}
              collapsed={1}
              style={{ fontSize: 16 }}
            />
          </div>
        ) : (
          <Typography color="text.secondary">
            No configuration available.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default ClientConfigurations;
